import { render, staticRenderFns } from "./Archives.vue?vue&type=template&id=7845e4cc&scoped=true&"
import script from "./Archives.vue?vue&type=script&lang=js&"
export * from "./Archives.vue?vue&type=script&lang=js&"
import style0 from "./Archives.vue?vue&type=style&index=0&id=7845e4cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7845e4cc",
  null
  
)

export default component.exports